import { render, staticRenderFns } from "./AgDataTableNew.vue?vue&type=template&id=67c9fd5e"
import script from "./AgDataTableNew.vue?vue&type=script&lang=js"
export * from "./AgDataTableNew.vue?vue&type=script&lang=js"
import style0 from "./AgDataTableNew.vue?vue&type=style&index=0&id=67c9fd5e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports